import { render, staticRenderFns } from "./day-insights.vue?vue&type=template&id=63720c54&"
import script from "./day-insights.vue?vue&type=script&lang=js&"
export * from "./day-insights.vue?vue&type=script&lang=js&"
import style0 from "./day-insights.vue?vue&type=style&index=0&id=63720c54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports